import React from "react";

import j1 from "../assets/j1.jpg";
import c2 from "../assets/c2.jpg";
import s1 from "../assets/s1.png";
import g1 from "../assets/g1.jpeg";
import git from "../assets/git.png";
import r4 from "../assets/r4.png";
import npm from "../assets/npm.png";
import m1 from "../assets/m1.png";
import fig2 from "../assets/fig2.jpg";
import node from "../assets/node.png";

import fire1 from "../assets/fire1.png";

import "./Skills.css";

function Skills() {
  return (
    <div className="">
      <div className="container">
        <div className="skills-body">
          <div className="row">
            <div className="col-xs-12 col-sm-6 col-md-8">
              <div className="img-sec">
                <h2
                  style={{
                    fontFamily: "Solway",
                    color: "teal",
                  }}
                >
                  <b> Languages</b>{" "}
                </h2>
                <br />
                <br />
                <img className="image-logo" src={c2} alt="img" />
                <img className="image-logo" src={j1} alt="img" />
                <img src={s1} className="image-logo" alt="img" />
                <img src={g1} className="image-logo" alt="img" />
                <br />
                <br />
                <br />
                <h2
                  style={{
                    fontFamily: "Solway",
                    color: "teal",
                  }}
                >
                  <b> Frameworks , Tools & DB</b>{" "}
                </h2>
                <br />
                <img className="sec-logo" src={r4} alt="img" />
                <img src={fire1} className="sec-logo" alt="img" />
                <img src={npm} className="third-logo" alt="img" />

                <img src={m1} className="third-logo" alt="img" />
                <img src={git} className="third-logo" alt="img" />
                <img src={fig2} className="sec-logo" alt="img" />
                <img src={node} className="third-logo" alt="img" />
              </div>
            </div>
            <div className="col-xs-6 col-md-4">
              <div className="text-section">
                <h5 style={{ fontFamily: "Solway", textAlign: "" }}>
                  I am a keen developer who likes to play with latest
                  technologies to build eye-catching products.
                  <br />
                  <br />
                  <b>Code</b> is an <b>Art</b> & that's why I love to experiment
                  to get the best results possible.
                  <br />
                  <br /> These are the languages & tools I use to develop
                  feature rich websites.
                  <br />
                  <br />
                  These skills & tools will keep on dancing , <b>
                    hover
                  </b> or <b>tap</b> over them to let them rest for a while.
                  &#128539;
                </h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Skills;
